import script from "./CommonTableColumn.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommonTableColumn.vue?vue&type=script&lang=ts&setup=true"

import "./CommonTableColumn.vue?vue&type=style&index=0&id=6093494a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6093494a"]])

export default __exports__